import { GraphQLTypeNameData, GRAPHQL_TYPENAMES, Instant } from 'modules/graphql/types';
import { AggregationType } from './aggregation';
import { ConversionEvent } from './conversionEvent';

export type ConversionId = number;
export enum ConversionState {
  Active = 'Active',
  Archived = 'Archived',
  Draft = 'Draft',
}

// Partial conversion types
export type ConversionIdData = { id: ConversionId };
export type ConversionProjectIdData = { projectId: number };
export type ConversionCreatedByIdData = { createdById: string | null };
export type ConversionCreatedAtData = { createdAt: Instant };
export type ConversionUpdatedByIdData = { updatedById: string | null };
export type ConversionUpdatedAtData = { updatedAt: Instant };
export type ConversionNameData = { name: string };
export type ConversionDescriptionData = { description: string | null };
export type ConversionEventsData<EventData extends Partial<ConversionEvent>> = {
  events: EventData[];
};
export type ConversionAggregationTypeData = { aggregationType: AggregationType };
export type ConversionStateData = { state: ConversionState };
export type ConversionCountData = { count: number | null };
export type ConversionRateData = { rate: number | null };
export type ConversionCampaignCountData = { campaignCount: number | null };
export type ConversionExperimentCountData = { experimentCount: number | null };
export type ConversionTypeNameData = GraphQLTypeNameData<GRAPHQL_TYPENAMES.CONVERSION>;

// Full type (NOTE: please add new conversion partial types to this union)
export type Conversion = ConversionIdData &
  ConversionProjectIdData &
  ConversionCreatedByIdData &
  ConversionCreatedAtData &
  ConversionUpdatedByIdData &
  ConversionUpdatedAtData &
  ConversionNameData &
  ConversionDescriptionData &
  ConversionEventsData<ConversionEvent> &
  ConversionAggregationTypeData &
  ConversionStateData &
  ConversionCountData &
  ConversionRateData &
  ConversionCampaignCountData &
  ConversionExperimentCountData &
  ConversionTypeNameData;

// Conversion GraphQL query (variables + response)
export type ConversionQueryVariables = { id: ConversionId };
export type ConversionQueryResponse<ConversionData extends Partial<Conversion>> = {
  conversion: ConversionData | null;
};
